import { showNotify } from 'vant';
import { replace, trim } from 'lodash-es';

export const checkPhone = (phone: string) => {
  const reg = /^1[3-9]\d{9}$/;
  if (!phone) {
    showNotify({ type: 'danger', message: '请输入手机号' });
    return false;
  }
  if (!reg.test(phone)) {
    showNotify({ type: 'danger', message: '请输入正确的手机号' });
    return false;
  }
  return true;
};

// 手机号方式验证
export const checkRegisterFrom = (phone = null, account = null, password = '', surePassword = null) => {
  const reg = /^1[3-9]\d{9}$/;
  const accountReg = /[0-9A-Za-z]{5,12}/;
  if (!phone) {
    showNotify({ type: 'danger', message: '请输入手机号' });
    return false;
  }
  if (!reg.test(phone)) {
    showNotify({ type: 'danger', message: '请输入正确的手机号' });
    return false;
  }
  if (!account) {
    showNotify({ type: 'danger', message: '请输入用户名' });
    return false;
  }
  if (!accountReg.test(account)) {
    showNotify({ type: 'danger', message: '请输入5-12位用户名,由字母或数字组成' });
    return false;
  }
  if (password?.length < 6) {
    showNotify({ type: 'danger', message: '密码长度不能小于6位' });

    return false;
  }
  if (password?.length > 16) {
    showNotify({ type: 'danger', message: '密码长度不能超过16位' });
    return false;
  }
  if (password != surePassword) {
    showNotify({ type: 'danger', message: '前后密码不一致' });
    return false;
  }
  return true;
};

export const verifyPassword = (password: string) => {
  if (!password || password.length < 6) {
    showNotify({ type: 'danger', message: '密码长度不能小于6位' });
    return false;
  }
  if (!password || password.length > 16) {
    showNotify({ type: 'danger', message: '密码长度不能超过16位' });
    return false;
  }
  return true;
};

export const emailRegisterFrom = (email: string) => {
  let reg = new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/);
  // const reg = /^\w+(-+.\w+)*@\w+(-.\w+)*.\w+(-.\w+)*$/;
  if (!reg.test(email)) {
    showNotify({ type: 'danger', message: '请输入正确的邮箱格式' });
    return false;
  }
  return true;
};

export const getCountryKey = (value: any, sysLoginOptions: any) => {
  const tmpObj = sysLoginOptions.value?.SMS_OPEN_COUNTRY;
  for (let key in tmpObj) {
    if (value === tmpObj[key]) {
      return key;
    }
  }
};

// 校验是否含有空格
export const checkAccount = s => {
  let reg = new RegExp(/^.{5,12}$/);
  return !reg.test(s);
};

export const isRegisterUserName = s => {
  let reg = /^[a-zA-Z][a-zA-Z0-9]{4,12}$/;
  if (!reg.test(s)) {
    showNotify({ type: 'danger', message: '会员账号必须以字母开头，5~12位字符' });
    return false;
  }

  return true;
};

export const formatterHandle = (text: string) => replace(trim(text), /[^0-9]/g, '');
